<ui-confirmation-dialog
    #confirmation
    header="time-off-v3.policyComponents.policyChangeConfirmationDialog.updatingTimeOffPolicy"
    primaryButtonLabel="confirm"
    secondaryButtonLabel="cancel"
>
    <p>
        {{
            'time-off-v3.policyComponents.policyChangeConfirmationDialog.policyChangesWillBeAppliedToAllEmployeesEnrolled'
                | translate
        }}
    </p>
    <form #form="ngForm">
        <mat-radio-group name="effectiveDateRadio" class="vertical" [(ngModel)]="timeOffPolicy.effectiveDate" required>
            <mat-label class="margin-bottom-2">{{
                'time-off-v3.policyComponents.policyChangeConfirmationDialog.selectAnEffectiveDateForYourChanges'
                    | translate
            }}</mat-label>
            <div class="flex col">
                <mat-radio-button class="margin-bottom-1" [value]="todayValue">{{
                    'time-off-v3.policyComponents.policyChangeConfirmationDialog.todayWithDate'
                        | translate: { date: todayDate | appDate: 'longDate' }
                }}</mat-radio-button>
                <mat-radio-button [value]="dateHiredValue">{{
                    'time-off-v3.policyComponents.policyChangeConfirmationDialog.employeeHireDate' | translate
                }}</mat-radio-button>
            </div>
        </mat-radio-group>
    </form>

    <ui-banner *ngIf="timeOffPolicy.effectiveDate === todayValue" variant="warning" class="margin-y-5 padding-right-1">
        <div>
            <p>
                <strong>{{
                    'time-off-v3.policyComponents.policyChangeConfirmationDialog.theChangesWillBeImplementedTodayWithDate'
                        | translate: { date: todayDate | appDate: 'longDate' }
                }}</strong>
            </p>
            <ul class="padding-left-3">
                <li
                    innerHTML="{{
                        'time-off-v3.policyComponents.policyChangeConfirmationDialog.beforeDateTheTimeOffBalanceAndAdjustmentsForAll'
                            | translate: { date: todayDate | appDate: 'longDate' }
                    }}"
                ></li>
                <li
                    innerHTML="{{
                        'time-off-v3.policyComponents.policyChangeConfirmationDialog.startingFromDateTheNewAccrualAndCarryoverRules'
                            | translate: { date: todayDate | appDate: 'longDate' }
                    }}"
                ></li>
                <li
                    innerHTML="{{
                        'time-off-v3.policyComponents.policyChangeConfirmationDialog.changesMadeAsOfTodayMayResultInAProration'
                            | translate
                    }}"
                ></li>
            </ul>
        </div>
    </ui-banner>

    <ui-banner
        *ngIf="timeOffPolicy.effectiveDate === dateHiredValue"
        variant="warning"
        class="margin-y-5 padding-right-1"
    >
        <div>
            <p>
                <strong>{{
                    'time-off-v3.policyComponents.policyChangeConfirmationDialog.theChangesWillBeAppliedRetroactivelyToAllEmployeesFromTheirHireDate'
                        | translate
                }}</strong>
            </p>
            <ul class="padding-left-3">
                <li>
                    <p>
                        {{
                            'time-off-v3.policyComponents.policyChangeConfirmationDialog.theTimeOffBalanceWillBeReset'
                                | translate
                        }}
                    </p>
                </li>
                <li>
                    <p>
                        {{
                            'time-off-v3.policyComponents.policyChangeConfirmationDialog.theTimeOffRequestsFromEmployeesAndManual'
                                | translate
                        }}
                    </p>
                </li>
            </ul>
        </div>
    </ui-banner>
</ui-confirmation-dialog>
